"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compactDynamicColumnsForViewQueryState = exports.getSelectedColumnsOrder = exports.changeColumnOrder = exports.removeFromColumnsOrder = exports.deselectColumn = exports.selectColumn = exports.toggleSelectColumn = exports.checkIsColumnSelected = void 0;
const ramda_1 = require("ramda");
const utils_1 = require("../../utils");
const checkIsColumnSelected = (columnId, { excludedColumns, selectAllMode }) => {
    const isExcluded = excludedColumns.includes(columnId);
    return !selectAllMode ? isExcluded : !isExcluded;
};
exports.checkIsColumnSelected = checkIsColumnSelected;
/**
 * - add column to excludedColumns if selectAll mode is "off" = select column
 * - add column to excludedColumns if selectAll mode is "on" = deselect column
 * - remove column from excludedColumns if selectAll mode is "off" = deselect column
 * - remove column from excludedColumns if selectAll mode is "on" = select column
*/
const toggleSelectColumn = (columnId, isChecked, { excludedColumns, selectAllMode }) => {
    const isExcludedInCurrentMode = (selectAllMode && !isChecked) || (!selectAllMode && isChecked);
    return (0, utils_1.updateUniqueItemListBasedOnValue)(columnId, isExcludedInCurrentMode)(excludedColumns);
};
exports.toggleSelectColumn = toggleSelectColumn;
/**
 * - add column to excludedColumns if selectAll mode is "off"
 * - remove column from excludedColumns if selectAll mode is "on"
*/
const selectColumn = (columnId, { excludedColumns, selectAllMode }) => {
    const isExcludedInCurrentMode = !selectAllMode;
    return (0, utils_1.updateUniqueItemListBasedOnValue)(columnId, isExcludedInCurrentMode)(excludedColumns);
};
exports.selectColumn = selectColumn;
/**
 * - add column to excludedColumns if selectAll mode is "on"
 * - remove column from excludedColumns if selectAll mode is "off"
*/
const deselectColumn = (columnId, { excludedColumns, selectAllMode }) => {
    const isExcludedInCurrentMode = selectAllMode;
    return (0, utils_1.updateUniqueItemListBasedOnValue)(columnId, isExcludedInCurrentMode)(excludedColumns);
};
exports.deselectColumn = deselectColumn;
const removeFromColumnsOrder = (columnId, { columnsOrder }) => {
    const currentIndex = columnsOrder.findIndex((id) => id === columnId);
    if (currentIndex > -1) {
        return (0, ramda_1.remove)(currentIndex, 1, columnsOrder);
    }
    return columnsOrder;
};
exports.removeFromColumnsOrder = removeFromColumnsOrder;
const changeColumnOrder = (columnId, { columnsOrder, targetIndex }) => {
    const columnsOrderWithoutReviewAttribute = (0, exports.removeFromColumnsOrder)(columnId, { columnsOrder });
    const newTargetIndex = targetIndex === -1 ? columnsOrder.length - 1 : targetIndex;
    return (0, ramda_1.insert)(newTargetIndex, columnId, columnsOrderWithoutReviewAttribute);
};
exports.changeColumnOrder = changeColumnOrder;
const getSelectedColumnsOrder = ({ columnsOrder = [], excludedColumns = [], selectAllMode = false, }) => columnsOrder.filter((columnId) => (0, exports.checkIsColumnSelected)(columnId, {
    excludedColumns,
    selectAllMode,
}));
exports.getSelectedColumnsOrder = getSelectedColumnsOrder;
const compactDynamicColumnsForViewQueryState = (dynamicColumns) => (Object.assign(Object.assign({}, dynamicColumns), { columnsOrder: (0, exports.getSelectedColumnsOrder)(dynamicColumns) }));
exports.compactDynamicColumnsForViewQueryState = compactDynamicColumnsForViewQueryState;
